// src/components/layout/Footer.tsx

import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="app-footer">
      <span>
        © {year} <strong>Toinup</strong> — Panel Administrativo
      </span>
      <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <i className="bi bi-shield-check" style={{ color: "var(--tp-green)" }} />
        v1.0.0 · Usuarios y Cupones
      </span>
    </footer>
  );
}
